import { render, staticRenderFns } from "./PlaceMediaForm.vue?vue&type=template&id=254f327e&scoped=true&"
import script from "./PlaceMediaForm.vue?vue&type=script&lang=js&"
export * from "./PlaceMediaForm.vue?vue&type=script&lang=js&"
import style0 from "./PlaceMediaForm.vue?vue&type=style&index=0&id=254f327e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254f327e",
  null
  
)

export default component.exports